/* Copyright (C) 2023 Advenio Tecnosys Pvt. Ltd.

*        All Rights Reserved

*

 * NOTICE: 

 * All information contained herein is, and remains

* the property of Advenio Tecnosys and its suppliers,

* if any.  The intellectual and technical concepts contained

* herein are proprietary to Advenio Tecnosys

* and its suppliers and may be covered by Indian, U.S. and Foreign Patents,

* patents in process, and are protected by trade secret or copyright law.

* Appropriation, redistribution, dissemination of this information or reproduction

* of this material is strictly forbidden unless prior written permission is obtained

* from Advenio Tecnosys Pvt. Ltd.

*

* Author: < Codebhendi, Ravi Ranjan Kumar, Sanket, Mylavarapu Sarath Sai, Ujjwal Singh >

*/
import React from "react";
import ReactDOM from "react-dom";
import { CookiesProvider } from "react-cookie";
import { Provider } from "react-redux";
import { applyMiddleware, createStore, compose } from "redux";
import { logger } from "redux-logger";
import thunk from "redux-thunk";
import { createPromise } from "redux-promise-middleware";
import { BrowserRouter } from "react-router-dom";
import rootReducer from "./reducers";
import App from "./App";
import "./index.css";

// const store=createStore(rootReducer, compose(applyMiddleware(thunk,createPromise(),logger),offline(offlineConfig)) )
export const store = createStore(
  rootReducer,
  applyMiddleware(thunk, createPromise(), logger)
);

// With logger disabled for prod purposes, author:Sai
// const store = createStore(rootReducer, applyMiddleware(thunk, createPromise()));
// const history = [];
ReactDOM.render(
  <Provider store={store}>
    <CookiesProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </CookiesProvider>
  </Provider>,
  document.getElementById("root")
);
